export const scrollToRef = (ref, offset = 0) => {
  if (ref && ref.current) {
    const top =
      ref.current.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
};
